import * as React from "react";
import { cn } from "../../lib/utils";
import { getColor } from "../../utils/cssColor";
/**
 * @example
 *
 * ```jsx
 * import { LegendEntryComponent } from "@skve/components"
 *
 * function Demo() {
 *   return <LegendEntryComponent name="Störung" unit="kW" xValue="3.7. 11:30 - 5.7. 15:45" yValue="0 - 0" color="green" />;
 * }
 * ```
 */
const LegendEntryComponent = ({ name, unit, color, xValue, yValue, extension, visible, mode, onToggle, }) => {
    const bgColor = React.useMemo(() => getColor(color), [color]);
    const tooltip = typeof name === "string" ? name : undefined;
    const hasXValue = !!xValue;
    const hasYValue = !!yValue;
    const hasUnit = !!unit;
    return (React.createElement("div", { className: "flex flex-row justify-between p-1 h-[24px] shrink-0 overflow-hidden gap-2" },
        React.createElement("div", { className: "flex flex-row items-center gap-2" },
            React.createElement("div", { className: "flex flex-1 flex-row items-center gap-1 truncate" },
                React.createElement("div", { className: cn("w-2 h-2 rounded-full mr-1 border shrink-0", onToggle && "cursor-pointer"), style: {
                        backgroundColor: visible ? bgColor : "transparent",
                        borderColor: bgColor,
                    }, onClick: onToggle }),
                React.createElement("div", { className: "truncate flex-1", title: tooltip }, name)),
            hasXValue && (React.createElement("div", { className: cn("truncate", mode === "optional" && "chartsframe__optional") }, xValue))),
        React.createElement("div", { className: "flex flex-row items-center gap-1 chartsframe__optional" },
            extension && React.createElement("div", null, extension),
            hasYValue && React.createElement("div", null, yValue),
            hasUnit && React.createElement("div", null, unit))));
};
LegendEntryComponent.displayName = "LegendEntryComponent";
export { LegendEntryComponent };
//# sourceMappingURL=legendEntryComponent.js.map